export default __webpack_public_path__ + "static/media/galliumos.54cabe83.svg";